<template>
	<div
		data-v-6f9effb1=""
		role="slider"
		aria-valuenow="4.5"
		aria-valuetext=""
		aria-valuemin="0"
		aria-valuemax="5"
		tabindex="0"
		class="webmd-rate"
		aria-label="4.5"
		v-show="false"
	>
		<!----><span
			class="webmd-rate__item webmd-rate__icon webmd-icon-star-on webmd-rate__icon--medium"
			style="cursor: auto;"
		>
			<!----><!---->
		</span><span
			class="webmd-rate__item webmd-rate__icon webmd-icon-star-on webmd-rate__icon--medium"
			style="cursor: auto;"
		>
			<!----><!---->
		</span><span
			class="webmd-rate__item webmd-rate__icon webmd-icon-star-on webmd-rate__icon--medium"
			style="cursor: auto;"
		>
			<!----><!---->
		</span><span
			class="webmd-rate__item webmd-rate__icon webmd-icon-star-on webmd-rate__icon--medium"
			style="cursor: auto;"
		>
			<!----><!---->
		</span><span
			class="webmd-rate__item webmd-rate__icon lastchild webmd-icon-star-on webmd-rate__icon--medium"
			style="cursor: auto;"
		>
			<i class="webmd-rate__decimal webmd-icon-star-on"></i><!---->
		</span><span
			class="webmd-rate--number"
		></span><!----><!---->
	</div>
</template>
